"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusIcon = exports.StatusIconColors = void 0;
var tslib_1 = require("tslib");
var ExcludeBaseIcon_1 = require("@tableau/icons/ExcludeBaseIcon");
var NotificationAlertLowShieldOutlineBaseIcon_1 = require("@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon");
var NotificationCheckIcon_1 = require("@tableau/icons/NotificationCheckIcon");
var NotificationInfoOutlineIcon_1 = require("@tableau/icons/NotificationInfoOutlineIcon");
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../gen-src/Localize");
exports.StatusIconColors = {
    Error: '#ba0517',
    Valid: '#22683e',
    Warning: '#6f3400',
    Info: '#05628a',
};
var IconMap = {
    error: React.createElement(ExcludeBaseIcon_1.ExcludeBaseIcon, { size: 14, color: exports.StatusIconColors.Error }),
    warning: React.createElement(NotificationAlertLowShieldOutlineBaseIcon_1.NotificationAlertLowShieldOutlineBaseIcon, { size: 14, color: exports.StatusIconColors.Warning }),
    info: React.createElement(NotificationInfoOutlineIcon_1.NotificationInfoOutlineIcon, { size: 14, color: exports.StatusIconColors.Info }),
    success: React.createElement(NotificationCheckIcon_1.NotificationCheckIcon, { size: 14, color: exports.StatusIconColors.Valid }),
};
function getAltText(type) {
    return Localize_1.Messages[type + "ToastPrefix"]();
}
var StatusIcon = function (_a) {
    var type = _a.type, htmlAttrs = tslib_1.__rest(_a, ["type"]);
    return React.cloneElement(IconMap[type], tslib_1.__assign({ 'aria-label': getAltText(type), key: type + "_statusIcon", role: undefined }, htmlAttrs));
};
exports.StatusIcon = StatusIcon;
//# sourceMappingURL=StatusIcons.js.map